var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowerPollution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_",
    transform: "translate(289.109 1992.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_271_",
    transform: "translate(0 90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M26.623,114.447h-14.4a3.331,3.331,0,0,1-3.332-3.427,3.38,3.38,0,0,1,3.379-3.241h1.019a1.143,1.143,0,0,0,1.157-1.079,1.111,1.111,0,0,0-1.111-1.143A3.331,3.331,0,0,1,10,102.13a3.38,3.38,0,0,1,3.379-3.241h1.065a1.111,1.111,0,0,0,0-2.222H3.334a3.334,3.334,0,1,1,0-6.667H28.892a3.334,3.334,0,0,1,0,6.667H25.558a1.111,1.111,0,0,0,0,2.222H34.4a3.38,3.38,0,0,1,3.379,3.241,3.331,3.331,0,0,1-3.332,3.427H23.336a1.111,1.111,0,0,0-1.111,1.143,1.143,1.143,0,0,0,1.157,1.079h3.287A3.331,3.331,0,0,1,30,111.206a3.38,3.38,0,0,1-3.379,3.241ZM12.27,110a1.143,1.143,0,0,0-1.157,1.079,1.111,1.111,0,0,0,1.111,1.143h14.4a1.143,1.143,0,0,0,1.157-1.079A1.111,1.111,0,0,0,26.669,110H23.382A3.38,3.38,0,0,1,20,106.761a3.331,3.331,0,0,1,3.332-3.427H34.448a1.111,1.111,0,0,0,1.111-1.143,1.143,1.143,0,0,0-1.157-1.079H25.558a3.334,3.334,0,1,1,0-6.667h3.334a1.111,1.111,0,0,0,0-2.222H3.334a1.111,1.111,0,0,0,0,2.222H14.446a3.334,3.334,0,1,1,0,6.667H13.381a1.143,1.143,0,0,0-1.157,1.079,1.111,1.111,0,0,0,1.111,1.143,3.331,3.331,0,0,1,3.332,3.427A3.38,3.38,0,0,1,13.288,110Z",
    transform: "translate(0 -90)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_",
    transform: "translate(2.222 100.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M30,225h2.222v2.222H30Z",
    transform: "translate(-30 -225)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_",
    transform: "translate(5.556 104.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M75,285h2.222v2.222H75Z",
    transform: "translate(-75 -285)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerPollution);
export default __webpack_public_path__ + "static/media/lower-pollution.e4ee5ad4baf668b7e78f488e50cbaa84.svg";
export { ForwardRef as ReactComponent };